import useRequest from "./request";

export async function getArticleDetail(articleId:any) {
  let { response, request } = useRequest<any>(
      "/social/article/share/detail/" + articleId,
      {
          method: "post",
      }
  );
  await request();
  return response;
}
export async function getcommentList(data:any) {
  let { response, request } = useRequest<any>(
      "/social/article/share/comment",
      {
          method: "post",
          data
      }
  );
  await request();
  return response;
}